module.exports = __webpack_public_path__ + "img/shequ3.628fdd7c.png";